import { render, staticRenderFns } from "./practicalList.vue?vue&type=template&id=c6bfb310&scoped=true"
import script from "./practicalList.vue?vue&type=script&lang=js"
export * from "./practicalList.vue?vue&type=script&lang=js"
import style0 from "./practicalList.vue?vue&type=style&index=0&id=c6bfb310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bfb310",
  null
  
)

export default component.exports